import NewSlotModal from './NewSlotModal';

export default NewSlotModal;
